import { v4 } from 'uuid';
import type {
  SerializedWorkflowEdge,
  WorkflowEdgeCondition,
  WorkflowEdgeOutcome,
} from '../types';
import type { WorkflowGraphNode } from './workflow-graph-node';

export const workflowEdgeCondition = (
  on: WorkflowEdgeOutcome
): WorkflowEdgeCondition => ({ on });

export class Edge {
  readonly id: string;
  readonly from: WorkflowGraphNode;
  readonly to: WorkflowGraphNode;
  readonly on: WorkflowEdgeOutcome;

  constructor(params: {
    from: WorkflowGraphNode;
    to: WorkflowGraphNode;
    on?: WorkflowEdgeOutcome;
    id?: string;
  }) {
    this.id = params.id ?? v4();
    this.from = params.from;
    this.to = params.to;
    this.on = params.on ?? 'success';
  }

  dedupeKey(): string {
    return `${this.from.id}:${this.to.id}:${this.on}`;
  }

  toSerializedEdge(params: {
    workflowId: string;
    ownerId: string;
    ownerOrgId: string;
    createdAt: string;
    updatedAt: string;
  }): SerializedWorkflowEdge {
    return {
      id: this.id,
      ownerId: params.ownerId,
      ownerOrgId: params.ownerOrgId,
      workflowId: params.workflowId,
      fromNodeId: this.from.id,
      toNodeId: this.to.id,
      condition: workflowEdgeCondition(this.on),
      createdAt: params.createdAt,
      updatedAt: params.updatedAt,
    };
  }
}
